import * as React from 'react';
import Badge from 'components/styleguide/badge/Badge';
import Tooltip from 'components/styleguide/tooltip/Tooltip';
import { FreshnessBadge } from './models';

// How fresh the person on the other side of the chat keeps their profile — the same tag the
// candidate search card shows, built from the same server-side copy.
export default function FreshnessTag({
  badge,
  idSuffix,
}: {
  badge: FreshnessBadge | null;
  idSuffix: string;
}) {
  if (!badge) return null;

  const id = `conversation-freshness-${idSuffix}`;

  return (
    <>
      <Badge variant={badge.variant} id={id}>
        {badge.label}
      </Badge>
      {badge.tooltip && <Tooltip targetId={id}>{badge.tooltip}</Tooltip>}
    </>
  );
}
